import React, { Component } from 'react';
import {CSVLink} from 'react-csv';

export default class WordSearchStatisticsMultiple extends Component {

  render() {
    return (
            <p className="lead">
            <span>Documents: {this.props.stats.documents}</span>{' '}
            <span>Lines: {this.props.stats.lines}</span>{' '}
            <CSVLink
              data={this.props.data}
              style={{color: 'white'}}
              filename={"DAMOS-search.csv"}
              className="btn btn-sm btn-success pull-right"
              target="_blank">Download as csv</CSVLink>
            </p>
)
  }





}



// WEBPACK FOOTER //
// ./src/components/wordsearchscreens/WordSearchStatisticsMultiple.js